<div class="period-field-wrapper"
     cdkOverlayOrigin
     #origin="cdkOverlayOrigin">
  <mat-form-field appearance="outline"
                  class="period-field"
                  [class.period-field--error]="invalid">
    <mat-label>Statement period</mat-label>
    <input matInput
           readonly
           [value]="displayText"
           [disabled]="disabled"
           (click)="togglePanel()" />
    <button matSuffix
            mat-icon-button
            type="button"
            aria-label="Open statement period picker"
            [disabled]="disabled"
            (click)="togglePanel()">
      <mat-icon>calendar_today</mat-icon>
    </button>
  </mat-form-field>
</div>

<ng-template cdkConnectedOverlay
             [cdkConnectedOverlayOrigin]="origin"
             [cdkConnectedOverlayOpen]="open"
             [cdkConnectedOverlayPositions]="overlayPositions"
             [cdkConnectedOverlayHasBackdrop]="true"
             cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
             (backdropClick)="close()"
             (detach)="close()">
  <div class="period-panel">
    <mat-button-toggle-group class="period-panel__tabs"
                             [hideSingleSelectionIndicator]="true"
                             [value]="activeTab"
                             (change)="selectTab($event.value)">
      <mat-button-toggle value="month">Month</mat-button-toggle>
      <mat-button-toggle value="year">Year</mat-button-toggle>
    </mat-button-toggle-group>

    <div class="period-panel__nav">
      <span class="period-panel__nav-label"
            *ngIf="level === 'year'">{{ navLabel }}</span>
      <button type="button"
              class="period-panel__nav-label period-panel__nav-label--back"
              *ngIf="level === 'month'"
              (click)="backToYearGrid()">
        {{ navLabel }}
        <mat-icon class="period-panel__nav-caret">arrow_drop_down</mat-icon>
      </button>
      <span class="period-panel__nav-spacer"></span>
      <button mat-icon-button
              type="button"
              aria-label="Previous"
              [disabled]="!canNavPrev"
              (click)="navigate(-1)">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button mat-icon-button
              type="button"
              aria-label="Next"
              [disabled]="!canNavNext"
              (click)="navigate(1)">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>

    <div class="period-panel__grid period-panel__grid--year"
         *ngIf="level === 'year'">
      <button *ngFor="let cell of yearCells; trackBy: trackByYear"
              type="button"
              class="period-cell"
              [class.period-cell--selected]="cell.selected"
              [disabled]="cell.disabled"
              (click)="selectYear(cell)">{{ cell.year }}</button>
    </div>

    <div class="period-panel__grid period-panel__grid--month"
         *ngIf="level === 'month'">
      <button *ngFor="let cell of monthCells; trackBy: trackByMonth"
              type="button"
              class="period-cell"
              [class.period-cell--selected]="cell.selected"
              [disabled]="cell.disabled"
              (click)="selectMonth(cell)">{{ cell.label }}</button>
    </div>
  </div>
</ng-template>
